/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { withRouter, Link } from 'react-router-dom'
import { Query, graphql, withApollo } from 'react-apollo'
import { Row, Col, Empty, Avatar } from 'antd'
import gql from 'graphql-tag'
import timeAgo from 'node-time-ago'
import UserAvatar from './UserAvatar'
import moment from 'moment'

const NOTIFICATIONS = gql`
    query userNotifications($user_uid: String, $searchFilter: SearchParams) {
		userNotifications(user_uid: $user_uid, searchFilter: $searchFilter)
    }
`

const NEW_NOTIFICATION = gql`
	subscription newNotification($user_uid: String) {
		newNotification(user_uid: $user_uid)
	}
`

const MARK_AS_SEEN = gql`
    mutation markAsSeenNotification($notif_uid: String) {
		markAsSeenNotification(notif_uid: $notif_uid)
    }
`

const MessageNotifBell = (props) => {
	const { client, history, user_uid, markAsSeen, ...rest } = props
	const [searchText, setSearchText] = useState('')

	return (
		<Query 
			query={NOTIFICATIONS}
			variables={{
				user_uid,
				searchFilter: { page: 1, pageSize: 10, searchText }
			}}
		>
			{({ loading, error, data, subscribeToMore }) => {
				let notifications = _.has(data,'userNotifications') ? data.userNotifications.data : []
				const unreadNotifications = _.filter(notifications, (i) => (i.is_seen == 0))
				
				return (
					<li 
						{...rest}
						onLoad={()=> {
							subscribeToMore({
								document: NEW_NOTIFICATION,
								variables: { user_uid },
								updateQuery: (prev, { subscriptionData }) => {
									if (!subscriptionData.data) return prev
									// console.log('[NEW_NOTIFICATION] prev', prev)
									// console.log('[NEW_NOTIFICATION] subscriptionData', subscriptionData)
									return Object.assign({}, prev, {
										userNotifications: subscriptionData.data.newNotification
									})
								}
							})
						}}
						className='dropdown notification-list'
					>
						<a className="nav-link dropdown-toggle  waves-effect waves-light" data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
							<i className="fe-bell noti-icon"></i>
							{
								(unreadNotifications.length > 0) &&
								<span className="badge badge-danger rounded-circle noti-icon-badge">
									{unreadNotifications.length}
								</span>
							}
							
						</a>
						<div className="dropdown-menu dropdown-menu-right dropdown-lg">

							<div className="dropdown-item noti-title">
								<h5 className="m-0">
									<span className="float-right">
										{/* <a href="#" className="text-dark">
											<small>Clear All</small>
										</a> */}
									</span>Notification
								</h5>
							</div>

							<div className="slimscroll noti-scroll">
								{
									(notifications.length == 0) && <Empty/>
								}
								{
									(notifications.length > 0) && notifications.map((notification, key) => {
										const notSeen = (notification.is_seen == 0) ? 'active' : null
										return (
											<a key={key} href="javascript:void(0);" className={`dropdown-item notify-item ${notSeen}`} onClick={() => {
												if (notSeen) {
													markAsSeen(notification.uid)
												}
												if (notification.link_url) {
													history.push(notification.link_url)
												}
											}}>
												<div className="notify-icon">
													{/* <img src="assets/images/users/avatar-1.jpg" className="img-fluid rounded-circle" alt="" />  */}
													<img className='img-fluid' src={`${process.env.REACT_APP_BACKEND_API}${notification.icon_url}`} alt="" />
												</div>
												<p className="notify-details">{notification.notification_message}</p>
												<p className="text-muted mb-0 user-msg">
													<small>{timeAgo(moment(notification.created_at).format('YYYY-MM-DD HH:mm:ss'))}</small>
												</p>
											</a>
										)
									})
								}
							</div>
							<Link to='/notifications' className="dropdown-item text-center text-primary notify-item notify-all">See all notifications</Link>
						</div>
					</li>
				)
			}}
		</Query>
	)
}

const composed = compose(
	withRouter,
	withApollo,
	graphql(MARK_AS_SEEN, {
		props({ mutate }) {
			return {
				markAsSeen(notif_uid) {
					return mutate({
						variables: { notif_uid },
					  	refetchQueries: ['userNotifications']
					})
				}
			}
		}
	})
)

export default composed(MessageNotifBell)